import { useState } from 'react';
import Title from '../custom/Title';
import CustomTabs from '../custom/newTabs';
import { InventoryShowcase } from '../$PVCInventory/InventoryShowcase';
import { InventoryRequest } from '../$PVCInventory/InventoryRequest';
import RGPManagement from '../$PVCInventory/RGPManagement';

function InboundTabs() {
    const [value, setValue] = useState(0);

    return (
        <>
            <CustomTabs
                labels={[
                    'Inventory Levels',
                    'Stock Transfer Orders',
                    'RGP MAnagement'
                ]}
                TabContents={[
                    <InventoryShowcase />,
                    <InventoryRequest />,
                    <RGPManagement />
                ]}
                value={value}
                handleChange={setValue}
            />
        </>
    )
}

export const InventoryManagement = () => {
    return (
        <div style={{ padding: '0 10px' }}>
            {/* <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Inventory Management PVC</Title>
            </div> */}
            <InboundTabs />
        </div>
    )
}

